var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","display":"flex","align-items":"center","justify-content":"center","padding":"20px"}},[(!_vm.loaded)?_c('b-flix-loader'):_vm._e(),(_vm.data)?_c('vue-json-pretty',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }